function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import RegularButton from "segments/desktop/core-components/button/regular-button/regular-button";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import TwoLinkButtonsButton from "segments/desktop/core-components/button/two-link-buttons-button/two-link-buttons-button";
import SignupComboButtonsButton from "segments/desktop/core-components/signup-combo-buttons-button/signup-combo-buttons-button";
import SignupButton from "segments/desktop/core-components/button/signup-button/signup-button";
import SubscribeButton from "segments/desktop/core-components/button/subscribe-button/subscribe-button";
import YouTubePopupButton from "segments/desktop/core-components/button/youtube-popup-button/youtube-popup-button";
import SignupAndYoutubeComboButton from "segments/desktop/core-components/button/signup-and-youtube-combo-button/signup-and-youtube-combo-button";
import { StyledButtton } from "./button.scss";
import { REGULAR_BUTTON_TYPE, SECONDARY_BUTTON_TYPE, SIGNUP_BUTTON_TYPE, TWO_LINK_BUTTONS_TYPE, SUBSCRIBE_BUTTON_TYPE, YOUTUBE_POPUP_LINK_TYPE, SIGNUP_COMBO_BUTTONS_TYPE, SIGNUP_AND_YOUTUBE_COMBO_BUTTONS_TYPE } from "./button-consts";
import DefaultProps from "./default-props";
class Button extends PureComponent {
    getButtonComponent() {
        const { buttonType } = this.props;
        switch(buttonType){
            case REGULAR_BUTTON_TYPE:
                return RegularButton;
            case SECONDARY_BUTTON_TYPE:
                return SecondaryButton;
            case SIGNUP_BUTTON_TYPE:
                return SignupButton;
            case TWO_LINK_BUTTONS_TYPE:
                return TwoLinkButtonsButton;
            case SIGNUP_COMBO_BUTTONS_TYPE:
                return SignupComboButtonsButton;
            case SUBSCRIBE_BUTTON_TYPE:
                return SubscribeButton;
            case YOUTUBE_POPUP_LINK_TYPE:
                return YouTubePopupButton;
            case SIGNUP_AND_YOUTUBE_COMBO_BUTTONS_TYPE:
                return SignupAndYoutubeComboButton;
            default:
                return null;
        }
    }
    render() {
        const ButtonComponent = this.getButtonComponent();
        if (!ButtonComponent) return null;
        const _this_props = this.props, { buttonType } = _this_props, restButtonConfig = _object_without_properties(_this_props, [
            "buttonType"
        ]);
        return /*#__PURE__*/ _jsx(StyledButtton, {
            className: "button",
            children: /*#__PURE__*/ _jsx(ButtonComponent, _object_spread({}, restButtonConfig))
        });
    }
}
export { Button as default };
Button.defaultProps = DefaultProps;
